import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setNavigation } from './navigationService';

export default function NavigationRegistrar() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setNavigation(navigate, location);
    }, [navigate, location]);

    return null;
}
